import { Box } from '@mui/material';

import { StyledChip } from '@/components/common/StyledChip';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';

export function RouteActionButtons() {
  const { updateRouteLocations } = useRoutesStore((state) => state.actions);

  const origin = useRoutesStore((state) => state.routeLocations[RouteLocationType.ORIGIN]);
  const destination = useRoutesStore((state) => state.routeLocations[RouteLocationType.DESTINATION]);

  const handleSwap = () => {
    updateRouteLocations({ routeLocationType: RouteLocationType.ORIGIN, location: destination });
    updateRouteLocations({ routeLocationType: RouteLocationType.DESTINATION, location: origin });
  };

  const handleReset = () => {
    updateRouteLocations({ routeLocationType: RouteLocationType.ORIGIN, location: undefined });
    updateRouteLocations({ routeLocationType: RouteLocationType.DESTINATION, location: undefined });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
      <StyledChip label="Tauschen" onClick={handleSwap} size="small" />
      <StyledChip label="Zurücksetzen" onClick={handleReset} size="small" />
    </Box>
  );
}
